import { useSelector } from "react-redux";
import Homeheader from "../components/Homeheader";
import Card from "../ui/Card";
import style from "./HomePage.module.css";

const operations = [
  {
    title: "Image Detection",
    description: "Upload an image and detect the containers in it.",
    imageSrc: `${process.env.PUBLIC_URL}/images/imageDetection.png`,
    link: "/image-detection",
    roles: ["admin"],
  },
  {
    title: "Live Detection",
    description: "Stream video feed and detect containers in real-time.",
    imageSrc: `${process.env.PUBLIC_URL}/images/liveDetection.png`,
    link: "/live-detection",
    roles: ["admin"],
  },
  {
    title: "Data Collection",
    description: "Collect data and upload to the cloud.",
    imageSrc: `${process.env.PUBLIC_URL}/images/dataCollection.png`,
    link: "/data-collection",
    roles: ["admin", "manager", "user"],
  },
  {
    title: "Map Results",
    description: "View the results on a map.",
    imageSrc: `${process.env.PUBLIC_URL}/images/mapResults.png`,
    link: "/map-results",
    roles: ["admin", "manager"],
  },
];
function HomePage() {
  const { user:{role} } = useSelector((state) => state.auth);
  console.log(role);
  return (
    <>
      <Homeheader />
      <div className={style.content}>
        {operations.map((operation) =>
          operation.roles.includes(role) ? (
            <Card key={operation.title} {...operation} />
          ) : null
        )}
      </div>
    </>
  );
}

export default HomePage;
// {operations.map((operation) =>  (
//   return operation.roles.includes(role) ? <Card key={operation.title} {...operation} /> : null
// ))}
